import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

const GOOGLE_CLIENT_ID = "1086035831113-pdk4nn6cu866lg0fmvalfl6054tu82mq.apps.googleusercontent.com";
const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/auth";

function formatError(error) {
    if (typeof error === 'string') {
        return <span style={{ color: 'red' }}>{error}</span>;
    }
    return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
}

function formatQuery(o) {
    return Object.keys(o).map(i => `${encodeURIComponent(i)}=${encodeURIComponent(o[i])}`).join('&');
}

class LoginWithNumber extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: null,
            token: null,
        };
    }

    componentDidMount() {
        this.get();
    }

    async get() {
        const response = await fetch(`/api/signin/get?id=${this.props.match.params.id}`);
        const result = await response.json();
        if (result.error) {
            this.setState({ loading: false, error: result.error });
        } else {
            this.setState({ loading: false, token: result.token });
        }
    }

    render() {
        if (this.state.loading) {
            return "Loading...";
        }
        if (this.state.error) {
            return formatError(this.state.error);
        }
        if (!this.state.token) {
            const params = {
                response_type: 'code',
                redirect_uri: window.location.origin + "/signin",
                client_id: GOOGLE_CLIENT_ID,
                scope: 'openid profile email',
                prompt: 'select_account',
                state: this.props.match.params.id,
            };
            const authUrl = `${GOOGLE_AUTH_URL}?${formatQuery(params)}`;
            window.location.href = authUrl;
            return (
                <div>Redirecting to <a href={authUrl}>Google Auth</a></div>
            );
        }
        return <div>Success</div>;
    }
}

class CheckLogin extends React.PureComponent {
    constructor(props) {
        super(props);

        const args = window.location.search.substring(1).split('&').map(p => p.split('=').map(i => decodeURIComponent(i)));
        let code = null;
        let state = null;
        for (let p of args) {
            if (p[0] === 'code') {
                code = p[1];
            } else if (p[0] === 'state') {
                state = p[1];
            }
        }

        this.state = {
            id: state | 0,
            code,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.auth();
    }

    async auth() {
        const loginResult = await (await fetch('/api/login', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                code: this.state.code
            }),
        })).json();
        if (loginResult.result !== 'OK') {
            this.setState({ loading: false, error: loginResult.error });
            return;
        }
        const response = await fetch('/api/signin/set', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: this.state.id,
                token: loginResult.token,
            }),
        });
        const result = await response.json();
        if (result.error) {
            this.setState({ loading: false, error: result.error });
        } else {
            this.setState({ loading: false });
        }
    }

    render() {
        if (this.state.loading) {
            return 'Login...';
        }
        if (this.state.error) {
            return formatError(this.state.error);
        }
        return <Redirect to={`/signin/${this.state.id}`} />;
    }
}

export default class Entry extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div>
                    <Switch>
                        <Route path="/signin/:id" component={LoginWithNumber} />
                        <Route component={CheckLogin} />
                    </Switch>
                </div>
            </div >
        );
    }
}